// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ProductExpandTokens } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

const XngLoadProducts: typeof LoadProducts = ({
    dispatch,
    getProductCollectionParameter,
    extraProductCollectionParameter,
    parameter: { carouselId, carouselType, numberOfProductsToDisplay, isProductDetailsPage, productId, isShellEdit },
}) => {
    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP = carouselType === "recentlyViewed" && isProductDetailsPage;
    const isRecentlyViewedOrRelatedProductOnPDP =
        (carouselType === "recentlyViewed" || carouselType === "relatedProducts") && isProductDetailsPage;

    // Xng-Changes: fix Duplicate exapnds
    getProductCollectionParameter.expand = [
        ...new Set([...(getProductCollectionParameter.expand || []), "images", "badges", "properties"]),
    ] as ProductExpandTokens;
    // Xng-Changes: add PDP productId to exclude it from extraProducts call results
    (getProductCollectionParameter as any).productId = isRecentlyViewedOrRelatedProductOnPDP ? productId : undefined;
    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit,
        }),
    );
};

replaceInChain(chain, LoadProducts, XngLoadProducts);
